// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__3FdYN","content":"styles_content__18PVV","action":"styles_action__3_b5o","list":"styles_list__1ygDz","img":"styles_img__Sqoau"};